import { render, staticRenderFns } from "./bo-toast.vue?vue&type=template&id=3a900024"
import script from "./bo-toast.vue?vue&type=script&lang=js"
export * from "./bo-toast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports